import { useTranslations } from 'next-intl';
import { ClawPassIcon } from '@/app/components/icons/ClawPassIcon';
import type { ClawUserVariant } from '@/app/types';
import { cn } from '@/app/utils';

interface UserTypeTagProps {
  variant: ClawUserVariant;
  className?: string;
}

const variantStyles: Record<ClawUserVariant, string> = {
  free: 'bg-system-white16 px-3 text-system-white48',
  clawPass:
    'bg-gradient-to-r from-[rgba(87,101,242,0.64)] to-[rgba(216,186,255,0.64)] px-1.5 gap-1 text-system-white light:text-white',
  trial: 'bg-[rgba(87,101,242,0.32)] px-3 text-[#ACB4FF] light:text-white',
};

export const UserTypeTag = ({ variant, className }: UserTypeTagProps) => {
  const t = useTranslations('claw.nav.userTag');

  return (
    <span
      className={cn(
        'inline-flex h-[18px] w-fit items-center whitespace-nowrap rounded-full text-[11px] leading-[1.4]',
        variantStyles[variant],
        className,
      )}
    >
      {variant === 'clawPass' && <ClawPassIcon className="size-3 shrink-0" />}
      {t(variant)}
    </span>
  );
};
